"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OverlayHandler = {
  currentOverlay: null,
  register: function register(overlay) {
    this.currentOverlay = overlay;
  },
  unregister: function unregister() {
    this.currentOverlay = null;
  },
  isShowing: function isShowing() {
    return this.currentOverlay === null ? false : this.currentOverlay.isShowing();
  },
  show: function show() {
    var _this = this;
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (this.currentOverlay === null) {
      return;
    }
    if (newState !== null) {
      this.currentOverlay.setNewState(newState, function () {
        _this.currentOverlay.show();
      });
    } else {
      this.currentOverlay.show();
    }
  },
  hide: function hide() {
    var _this2 = this;
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    if (this.currentOverlay === null) {
      return;
    }
    this.currentOverlay.setNewState({}, function () {
      _this2.currentOverlay.hide(callback);
    });
  }
};
var _default = exports["default"] = OverlayHandler;